import { createApiRef } from '@backstage/core-plugin-api';

import { NpsResponse } from './types';

export interface NpsApi {
  getNPS(): Promise<NpsResponse>;
}

export const npsApiRef = createApiRef<NpsApi>({
  id: 'plugin.nps.service',
});
